"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoForTrackingMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class UserInfoForTrackingMapper {
    toDomain(result) {
        const id = lodash_1.default.get(result, "data.getUser.id");
        const userLanguage = lodash_1.default.get(result, "data.getUser.language");
        const holdingBrand = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.holding.brand");
        const holdingCp = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.holding.address.zip");
        const holdingId = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.holding.id");
        const holdingName = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.holding.name");
        return {
            id,
            userLanguage,
            holdingBrand,
            holdingCp,
            holdingId,
            holdingName,
        };
    }
}
exports.UserInfoForTrackingMapper = UserInfoForTrackingMapper;
